// extracted by mini-css-extract-plugin
export default {"information":"mainInfo_information__2Piy9","background-gradient":"mainInfo_background-gradient__auI+R"};